import React, { useEffect, useRef } from 'react'

const SarasCheckBox2 = (props) => {
    const { value, className, onClick, id, name } = props;

    const [isChecked, setIsChecked] = React.useState(false);
    const checkBoxRef = useRef();

    const initializeValue = () => {
        if (value && (value === 'Yes' || value === "1"))
            setIsChecked(value)
        else
            setIsChecked(false)
    }

    useEffect(initializeValue, [value])

    const onCheckBoxClick = (e) => {
        const isChecked = checkBoxRef.current.checked;
        setIsChecked(isChecked)
        if (onClick) onClick(checkBoxRef, isChecked ? '1' : '0')
    }


    return (
        <input ref={checkBoxRef} type='checkbox' onChange={onCheckBoxClick} checked={isChecked} className={className} 
            id={id} name={name}
        />
    )

}

export default SarasCheckBox2